export class NotFoundApiError extends Error {
  constructor() {
    super('Not found error occurred')
    Object.setPrototypeOf(this, NotFoundApiError.prototype)
  }
}
